import { NotifyHelper } from "../../../helpers/toast";
import {
  eDmMucHocPhiTheoCTDTActionIds,
  eDmMucHocPhiTheoCTDTActionsObj,
} from "../../action-types/category/IDmMucHocPhiTheoCTDTActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const mucHocPhiTheoCTDTActions = {
  ...generateActions(eDmMucHocPhiTheoCTDTActionsObj, "MUC_HOC_PHI_THEO_CTDT"),
  ...generateActionForKey(
    eDmMucHocPhiTheoCTDTActionIds,
    "MUC_HOC_PHI_THEO_CTDT",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    },
  ),
  ...generateActionForKey(
    eDmMucHocPhiTheoCTDTActionIds,
    "MUC_HOC_PHI_THEO_CTDT",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(
    eDmMucHocPhiTheoCTDTActionIds,
    "MUC_HOC_PHI_THEO_CTDT",
    "LOCK_SUCCESS",
    () => {
      NotifyHelper.Success("Khoá thành công");
    },
  ),
  ...generateActionForKey(
    eDmMucHocPhiTheoCTDTActionIds,
    "MUC_HOC_PHI_THEO_CTDT",
    "UNLOCK_SUCCESS",
    () => {
      NotifyHelper.Success("Mở khóa thành công");
    },
  ),
  ...generateActionForKey(
    eDmMucHocPhiTheoCTDTActionIds,
    "MUC_HOC_PHI_THEO_CTDT",
    "COPY_SUCCESS",
    (so_dong: any) => {
      const n = Number(so_dong) || 0;
      NotifyHelper.Success(
        n > 0
          ? `Đã sao chép ${n} dòng đơn giá (chỉ kỳ đồng giá)`
          : "Không có kỳ nào đồng giá để sao chép",
      );
    },
  ),
  ...generateActionForKey(
    eDmMucHocPhiTheoCTDTActionIds,
    "MUC_HOC_PHI_THEO_CTDT",
    "COPY_ERROR",
    () => {
      NotifyHelper.Error("Sao chép không thành công");
    },
  ),
};
